import styled from 'styled-components';

import {PageContent} from '../../styles/pages/pages';
import {LoadingContainer} from '../../styles/components/layout';

export const DropInContent = styled(PageContent)`
  padding: 1rem 2rem 2rem;
  min-height: 60rem;
`;

export const LoadingWrapper = styled(LoadingContainer)`
  margin-top: 16rem;
`;

export const UpdateButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 1rem;
`;

export const Info = styled.div`
  padding: 1rem 0 2rem;
  font-size: 1.4rem;
  color: ${p => p.theme.textColor};
`;
